import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { ChevronDown24Filled } from '@fluentui/react-icons';
import GroupAdminHeader from "../../Comman/Header";
import GroupAdminSidebar from "../../Comman/Sidebar";
import api from "../../../CommonApi/axios";
import $ from "jquery";
import headers from "../../../CommonApi/headers";
import useDrawer from "../../../context/DrawerContext";
import { submitEditForm } from "../../Comman/EditCommonFun/EditCommonFunction";
import useError from "../../Comman/Error/useError";
import { applyFilterMeHandlers } from "../../Comman/Error/jqueryUtils";
import { SubmitformButton } from "../../Comman/Error/SubmitformButton";
import { ErrorMessage } from "../../Comman/Error/ErrorMessage";
import { passwordValidation, validateEmail } from "../../Comman/AddCommonFun/validation";
import { HeaderSection } from "../../Comman/Error/HeaderSection";

const SelectField = ({ field, value, handleChange }) => (
  <div className="col-md-6 mb-10">
    <label className="required form-label">{field.label}</label>
    <div style={{
      position: 'relative',
      display: 'block'
    }}>
      <select
        className={field.className}
        name={field.name}
        value={value}
        onChange={handleChange}
        required
        style={{
          appearance: 'none',
          paddingRight: '35px',
          cursor: 'pointer'
        }}
      >
        <option value="">Select {field.label}</option>
        {field.options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
      <span style={{
        position: 'absolute',
        right: '10px',
        top: '50%',
        transform: 'translateY(-50%)',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center'
      }}>
        <ChevronDown24Filled style={{ fontSize: '18px', color: '#6c757d' }} />
      </span>
    </div>
  </div>
);

const FormField = ({ field, value, handleChange }) => (
  <div className="col-md-6 mb-10">
    <label className="required form-label">{field.label}</label>
    <input
      type={field.type}
      className={field.className}
      placeholder={field.placeholder}
      name={field.name}
      value={value}
      onChange={handleChange}
      required
    />
  </div>
);

export default function GroupAdminEditManager() {

  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  const [name, setname] = useState("");
  const [phone_number, setphone_number] = useState("");
  const [manager_type, setmanager_type] = useState("");

  useEffect(() => {
    applyFilterMeHandlers(); // Apply the jQuery handlers
  }, []);

  const { error, showError, clearError } = useError();

  const history = useHistory();
  const { id } = useParams();

  useEffect(() => {
    ManagerDetailsGet();
  }, []);

  function ManagerDetailsGet() {
    api.get(`/groupadmin/manager/${id}`, { headers }).then((res) => {
      const tableData = res.data.data;
      setname(tableData.name);
      setemail(tableData.email);
      // setpassword(tableData.password);
      setphone_number(tableData.phone_number);
      setmanager_type(tableData.manager_type);
    });
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case 'name':
        setname(value);
        break;
      case 'manager_type':
        setmanager_type(value);
        break;
      case 'phone_number':
        setphone_number(value);
        break;
      case 'email':
        setemail(value);
        break;
      case 'password':
        setpassword(value);
        break;
      default:
        break;
    }
  };

  const formFields = [
    { name: 'name', type: 'text', placeholder: 'Manager Name', label: 'Manager Name', className: "form-control form-control-solid" },
    { name: 'manager_type', type: 'select', label: 'Manager Type', className: "form-control form-control-solid", options: ['Food truck', 'Restaurant'] },
    { name: 'phone_number', type: 'filterm text', placeholder: 'Phone Number', label: 'Phone Number', className: "form-control form-control-solid filterme" },
    { name: 'email', type: 'email', placeholder: 'Email', label: 'Email', className: "form-control form-control-solid" },
    { name: 'password', type: 'password', placeholder: 'Password', label: 'Password', className: "form-control form-control-solid" },
  ];

  function handleSubmit(event) {
    event.preventDefault();
    showError(null);

    if (
      name.toString().trim().length < 0 ||
      name.toString().trim().length < 3
    ) {
      showError("Manager Name Must Be at least 3 character Long");
    }
    // else if (phone_number.toString().trim().length < 0 || phone_number.toString().trim().length < 10) {
    //     showError('Phone Number Must Be at least 10 character Long');
    // }
    else if (!validateEmail(email)) {
      showError("Invalid Email");
    } else if (
      (password && password.toString().trim().length > 0 && !passwordValidation(password)) ||
      (password && password.toString().trim().split(" ").join("").length < 6)
    ) {
      showError("Password must be at least 6 characters long and not contain any spaces.");
      $(".loader").hide();
    }  else {

      const formData = new FormData();

        formData.append("branch_id", id);
        formData.append("name", name);
        formData.append("manager_type", manager_type);
        formData.append("email", email);
        formData.append("phone_number", phone_number);
        if(password){
          formData.append("password", password);
        }
      // console.log("item" , item)

      // api
      //   .patch(`/groupadmin/manager/${id}`, formData, { headers })
      //   .then((res) => {
         
      //     showSuccessNotification("Manager details has been edited successfully");

      //     history.goBack();
      //   })
      //   .catch((err) => {
      //     if (err.response) {
      //       showError(err.response?.data?.error?.message);
      //     } else if (err.request) {
      //       showError(err.request);
      //     } else {
      //       showError(err.message);
      //     }
      //   });

        submitEditForm(`/groupadmin/manager/${id}`, formData, history, showError, clearError, "Manager details has been edited successfully");

    }
  }

  const { drawerPos, handleDrawer, maingetViewDetails } = useDrawer();


  return (
    <React.Fragment>
      <div
        id="kt_body"
        className="header-fixed header-tablet-and-mobile-fixed toolbar-enabled toolbar-fixed aside-enabled aside-fixed"
      >
        <div className="d-flex flex-column flex-root">
          <div className="page d-flex flex-row flex-column-fluid">
            <GroupAdminSidebar drawerPos={drawerPos} handleDrawer={handleDrawer}/>
            <div
              className="wrapper d-flex flex-column flex-row-fluid"
              id="kt_wrapper"
            >
              <GroupAdminHeader />
              <div
                className=" d-flex flex-column flex-column-fluid"
                id="kt_content"
              >
                <div id="kt_content_container" className="mx-7">
                <main className={`main_ ${maingetViewDetails.join(" ")}`}>
                  <HeaderSection title="Edit Manager" goBackHandler={() => history.goBack()} />
                  <div className="py-5">
                    <div className="card card-docs mb-2">
                      <div className="card-body fs-6 py-15 px-10 py-lg-15 px-lg-15 text-gray-700">
                        <div className="rounded border p-10">
                          <form onSubmit={handleSubmit}>
                            <div className="row col-md-12">
                              <div className="mb-10">
                                <h6>Manager Details Edit</h6>
                              </div>
                              {formFields.map((field, index) => (
                                field.type === 'select' ? (
                                  <SelectField
                                    key={index}
                                    field={field}
                                    value={
                                      field.name === 'name' ? name :
                                      field.name === 'manager_type' ? manager_type :
                                      field.name === 'phone_number' ? phone_number :
                                      field.name === 'email' ? email :
                                      field.name === 'password' ? password : ''
                                    }
                                    handleChange={handleChange}
                                  />
                                ) : (
                                  <FormField
                                    key={index}
                                    field={field}
                                    value={
                                      field.name === 'name' ? name :
                                      field.name === 'manager_type' ? manager_type :
                                      field.name === 'phone_number' ? phone_number :
                                      field.name === 'email' ? email :
                                      field.name === 'password' ? password : ''
                                    }
                                    handleChange={handleChange}
                                  />
                                )
                              ))}
                            </div>

                            <ErrorMessage error={error} />
                             <SubmitformButton handleSubmit={handleSubmit} onCancel={() => history.goBack()} />
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                  </main>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
